import { useQuery } from '@tanstack/react-query';

export interface CategoryStream {
    num: number;
    name: string;
    stream_type: string;
    stream_id: number;
    stream_icon: string;
    epg_channel_id: string;
    added: string;
    category_id: string;
    custom_sid: string;
    tv_archive: number;
    direct_source: string;
    tv_archive_duration: number;
    // VOD/Series specific fields
    container_extension?: string;
    category_name?: string;
    duration?: number;
    series_id?: number;
}

interface UseCategoryStreamsParams {
    baseUrl: string;
    username: string;
    password: string;
    categoryId: string | null;
    streamType: 'get_live_streams' | 'get_vod_streams' | 'get_series';
}

export const useCategoryStreams = ({
                                       baseUrl,
                                       username,
                                       password,
                                       categoryId,
                                       streamType
                                   }: UseCategoryStreamsParams) => {
    return useQuery<CategoryStream[], Error>({
        queryKey: ['category-streams', baseUrl, username, categoryId, streamType],
        queryFn: async () => {
            if (!categoryId) {
                return [];
            }

            const url = `${baseUrl}/player_api.php?username=${username}&password=${password}&action=${streamType}&category_id=${categoryId}`;

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Failed to fetch streams: ${response.statusText}`);
            }

            const data: CategoryStream[] = await response.json();
            return data;
        },
        enabled: !!categoryId && !!streamType, // Only run query if both exist
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
    });
};